'use client';

import { BarChart, Bar, XAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';
import { BarChart3 } from 'lucide-react';

const financialChartData = [
    { month: 'Jul', income: 65000000, expense: 45000000 },
    { month: 'Agt', income: 45000000, expense: 35000000 },
    { month: 'Sep', income: 80000000, expense: 55000000 },
    { month: 'Okt', income: 55000000, expense: 40000000 },
    { month: 'Nov', income: 90000000, expense: 65000000 },
    { month: 'Des', income: 70000000, expense: 50000000 },
    { month: 'Jan', income: 85000000, expense: 60000000 },
];

const CustomTooltip = ({ active, payload, label }: any) => {
    if (active && payload && payload.length) {
        return (
            <div className="bg-surface border border-border-main p-4 rounded-2xl shadow-xl">
                <p className="font-black text-foreground mb-2 text-sm">{label} 2024</p>
                <div className="flex flex-col gap-1.5">
                    <div className="flex items-center gap-2">
                        <div className="w-2.5 h-2.5 rounded-full bg-primary"></div>
                        <span className="text-xs text-secondary font-bold uppercase tracking-wider">Pendapatan:</span>
                        <span className="text-xs font-black text-foreground ml-auto">
                            {new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }).format(payload[0].value)}
                        </span>
                    </div>
                    <div className="flex items-center gap-2">
                        <div className="w-2.5 h-2.5 rounded-full bg-error"></div>
                        <span className="text-xs text-secondary font-bold uppercase tracking-wider">Pengeluaran:</span>
                        <span className="text-xs font-black text-foreground ml-auto">
                            {new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }).format(payload[1].value)}
                        </span>
                    </div>
                </div>
            </div>
        );
    }
    return null;
};

export default function FinancialChart() {
    return (
        <div className="bg-surface border border-border-main p-8 lg:p-10 rounded-[2.5rem] shadow-sm flex flex-col h-[380px]">
            <div className="flex items-center justify-between mb-10">
                <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-xl bg-primary-soft flex items-center justify-center shadow-sm">
                        <BarChart3 className="w-5 h-5 text-primary" />
                    </div>
                    <div>
                        <h3 className="text-lg font-black text-foreground">Tren Pemasukan & Pengeluaran</h3>
                        <p className="text-[10px] text-muted font-bold uppercase tracking-widest mt-1">Arus Kas Bulanan Unit</p>
                    </div>
                </div>
                <div className="flex gap-6">
                    <div className="flex items-center gap-2">
                        <div className="w-3 h-3 rounded-full bg-primary"></div>
                        <span className="text-[10px] font-black text-secondary uppercase tracking-widest">Pemasukan</span>
                    </div>
                    <div className="flex items-center gap-2">
                        <div className="w-3 h-3 rounded-full bg-error"></div>
                        <span className="text-[10px] font-black text-secondary uppercase tracking-widest">Pengeluaran</span>
                    </div>
                </div>
            </div>

            <div className="w-full flex-1">
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart
                        data={financialChartData}
                        margin={{
                            top: 10,
                            right: 0,
                            left: 0,
                            bottom: 0,
                        }}
                        barGap={10}
                    >
                        <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E2ECE6" opacity={0.5} />
                        <XAxis
                            dataKey="month"
                            axisLine={false}
                            tickLine={false}
                            tick={{ fill: '#8da495', fontSize: 10, fontWeight: 900 }}
                            dy={10}
                        />
                        <Tooltip
                            content={<CustomTooltip />}
                            cursor={{ fill: 'var(--color-primary-soft)', opacity: 0.3, radius: 12 }}
                        />
                        <Bar
                            dataKey="income"
                            fill="var(--color-primary)"
                            radius={[6, 6, 6, 6]}
                            barSize={16}
                            animationDuration={1500}
                        />
                        <Bar
                            dataKey="expense"
                            fill="var(--color-error)"
                            radius={[6, 6, 6, 6]}
                            barSize={16}
                            animationDuration={1500}
                        />
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
}
